import * as React from 'react';

type ImageProps = {
  content: string | { url: string, width: number, height: number };
  width?: number;
  height?: number;
}

const Image = ({ content, width, height }: ImageProps) => {
  const src = typeof content === 'string' ? content : content?.url;
  const blockWidth = content?.url ? height * content?.width / content?.height : height;

  if (!src) {
    return null;
  }

  return (
    <div
      className="image-component"
      style={{
        height: `${height}px`,
        width: width ? `${width}px` : `${blockWidth}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img
        src={src}
        alt="ticker-image"
        style={{
          height: '100%',
          width: '100%',
          objectFit: 'contain'
        }}
      />
    </div>
  );
};

export default Image;
